<template>
  <div class="dashboard_content">
    <div class="dashboardHelpList">
      <h1 class="contentTitle">お知らせ</h1>
      <router-link to="/notifications" class="router">
        <div class="allView">全て見る</div>
      </router-link>
      <div class="help" v-for="(item, key) in helpItems" :key="item.index">
        <div class="helpDate" v-text="item.date" />
        <div class="helpTitle" v-text="item.title" />
        <div class="helpText" v-text="item.text" />
        <hr v-if="key < 2" />
      </div>
    </div>
  </div>
</template>

<script>
import showHelpModalWindow from '../modalWindow/showHelpModalWindow.vue'

export default {
  props: {
    helpMsgs: Array
  },
  data() {
    return {
      maxShowLength: 3,
      dashboardImage: require('../../img/dashboardMain.png')
    }
  },
  computed: {
    helpItems() {
      var items = []
      if (this.helpMsgs == null) {
        return items
      }

      for (let msg of this.helpMsgs) {
        var item = Object()
        item.title = msg.title
        item.text = msg.value
        var d = new Date(msg.updateDateTime)
        item.date =
          d.getFullYear() +
          '年' +
          (d.getMonth() + 1) +
          '月' +
          d.getDate() +
          '日 ' +
          d.toLocaleTimeString()
        items.push(item)

        // 最大表示件数を超えたら終了
        if (items.length === this.maxShowLength) {
          break
        }
      }
      return items
    }
  },
  methods: {},
  components: {
    showHelpModalWindow
  }
}
</script>

<style scoped>
.helpText,
.helpTitle {
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardHelpList.vue